import React from 'react';
import {
  BrowserRouter as Router,
  Routes, Route, Navigate
} from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

// Pages
import Login from './pages/Login';
import VendorRegister from './pages/VendorRegister';
import VerifyOtp from './pages/VerifyOtp';
import AdminDashboard from './pages/AdminDashboard';
import VendorDashboard from './pages/VendorDashboard';
import Engineers from './pages/Engineers';
import Customers from './pages/Customers';
import Inventory from './pages/Inventory';
import Tickets from './pages/Tickets';
import Reports from './pages/Reports';
import VendorManagement from './pages/VendorManagement';
import LiveMap from './pages/LiveMap';

// Layout
import Layout from './components/Layout';

const PrivateRoute = ({ children, adminOnly }) => {
  const { user, loading, isPlatformAdmin } = useAuth();
  if (loading) return (
    <div style={{
      display:'flex', alignItems:'center',
      justifyContent:'center', height:'100vh',
      color:'var(--accent)',
      fontFamily:'DM Mono, monospace'
    }}>
      Loading IRONWALL...
    </div>
  );
  if (!user) return <Navigate to="/login" />;
  if (adminOnly && !isPlatformAdmin)
    return <Navigate to="/dashboard" />;
  return children;
};

function AppRoutes() {
  const { user, isPlatformAdmin } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={
        user
          ? <Navigate to="/dashboard" />
          : <Login />
      } />
      <Route path="/register" element={
        user
          ? <Navigate to="/dashboard" />
          : <VendorRegister />
      } />
      <Route path="/verify-otp" element={
        user
          ? <Navigate to="/dashboard" />
          : <VerifyOtp />
      } />
      <Route path="/" element={
        <Navigate to="/dashboard" />
      } />
      <Route path="/dashboard" element={
        <PrivateRoute>
          <Layout>
            {isPlatformAdmin
              ? <AdminDashboard />
              : <VendorDashboard />}
          </Layout>
        </PrivateRoute>
      } />
      <Route path="/vendors" element={
        <PrivateRoute adminOnly>
          <Layout><VendorManagement /></Layout>
        </PrivateRoute>
      } />
      <Route path="/engineers" element={
        <PrivateRoute>
          <Layout><Engineers /></Layout>
        </PrivateRoute>
      } />
      <Route path="/customers" element={
        <PrivateRoute>
          <Layout><Customers /></Layout>
        </PrivateRoute>
      } />
      <Route path="/inventory" element={
        <PrivateRoute>
          <Layout><Inventory /></Layout>
        </PrivateRoute>
      } />
      <Route path="/tickets" element={
        <PrivateRoute>
          <Layout><Tickets /></Layout>
        </PrivateRoute>
      } />
      <Route path="/map" element={
        <PrivateRoute>
          <Layout><LiveMap /></Layout>
        </PrivateRoute>
      } />
      <Route path="/reports" element={
        <PrivateRoute>
          <Layout><Reports /></Layout>
        </PrivateRoute>
      } />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App;